(ns dre.pages.frontpage.keyword-search.events
  (:require
   [re-frame.core :as rf]))

(def default-search-query
  {:query/type :articles
   :query/pills []})

(rf/reg-event-db
 ::init-db
 (fn [db _]
   (assoc-in db [:search :search-query] default-search-query)))
